<template>
  <div
    :class="{
      'menu-card-wrapper': true,
      'menu-card-selected': isSelected,
      'shadow-2': true,
    }"
    @click="onClicked"
  >
    <div class="menu-card-left-panel w-100">
      <div class="menu-card-info gap-row-sm w-100">
        <div class="menu-card-titles gap-row-zero">
          <div class="qrw-heading-xs" :class="{
            bold: isSelected
          }" v-if="!editing_title">
            {{ menu.title }}
            <BaseIcon
              class="edit-icon"
              icon="edit-02"
              @click="showEditUI"
              v-if="isSelected"
            />
          </div>
          <div class="qrw-heading-md edit-block w-100" v-else>
            <BaseInput
              class="w-100"
              fullWidth
              inputId="editMenuInput"
              v-model="edit_title_value"
            />
            <BaseButton
              size="md"
              icon="check"
              color="v1-grey-3"
              variant="secondary"
              class="ml-8"
              @click="saveTitle"
            />
          </div>
          <span class="qrw-label-sm" :class="{
      'v1-grey-6-color': isSelected,
      'v1-grey-8-color': !isSelected
    }">
            {{ menu.categories.length }} {{ $t("nouns.categories") }} •
            {{ menu.products.length }} {{ $t("nouns.dishes") }}
          </span>
        </div>

        <div class="card-locales">
          <img
            :src="`/flags/${menu.original_locale}.png`"
            v-if="menu.original_locale"
          />
          <img
            v-for="locale in menu.locales"
            :key="locale"
            :src="`/flags/${locale}.png`"
          />
        </div>
      </div>

      <!-- <div class="menu-card-pos-icons" v-if="!isPlaceholder">
        <img
          src="/icons/poster-integration.png"
          v-if="menu.metadata.is_poster_menu"
        />
        <img src="/icons/iiko.png" v-if="menu.metadata.is_iiko_menu" />
      </div> -->

      <div class="edited-stamp qrw-label-sm" :class="{
      'v1-grey-7-color': isSelected,
      'v1-grey-6-color': !isSelected
    }">
      {{ formattedLastEditedDate}}
    </div>

    </div>


    <!-- <div class="card-modes ml-8" v-if="!isPlaceholder">
      <div
        v-for="(v, k) in menuModes"
        :key="k"
        :class="{
          'mode-badge': !!v,
          [k]: !!v,
        }"
      ></div>
    </div> -->
  </div>
</template>

<script>
import FormatPastDate from '@/services/prettydate/formatPastDate'

export default {
  props: {
    menu: Object,
    isSelected: Boolean,
    isPlaceholder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing_title: false,
      edit_title_value: null,
    };
  },
  mounted() {
    this.edit_title_value = this.menu.title;

    if (this.isPlaceholder) {
      this.edit_title_value = "";
      this.showEditUI();
    }
  },
  methods: {
    saveTitle() {
      this.$emit("rename", this.edit_title_value);
      this.editing_title = false;
    },
    showEditUI() {
      this.edit_title_value = this.menu.title;
      this.editing_title = true;

      this.$nextTick(() => {
        document.getElementById("editMenuInput").focus();
      });
    },
    onClicked() {
      if (!this.editing_title) this.$emit("select", this.menu);
    },
  },
  computed: {
    menuModes() {
      return this.$store.getters["menu/menuModes"](this.menu._id);
    },
    formattedLastEditedDate() {
      if (!this.menu.updated_at) return '';
      return `${this.$t('menu_manager.last_edited')} ${FormatPastDate(this.menu.updated_at, this.$i18n.locale)}`;
    }
  },
};
</script>

<style scoped>
.menu-card-wrapper {
  border-radius: 8px;
  padding: 16px 16px 12px 16px;

  position: relative;
  width: 400px;
  height: 148px;
  max-height: 160px;
  max-width: 400px;
  cursor: pointer;

  box-sizing: border-box;

  background: var(--v1-grey-1-color);
  color: var(--v1-grey-10-color);

  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.menu-card-left-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  /* row-gap: 24px; */
  justify-content: space-between;
}

.menu-card-selected {
  background: var(--v1-grey-10-color);
  color: var(--v1-grey-3-color);
}

.mode-badge {
  width: 10px;
  height: 10px;
  max-width: 10px;
  max-height: 10px;

  margin-bottom: 4px;

  border-radius: 1px;
}

.menu-card-pos-icons img {
  width: 24px;
  height: 24px;
  max-height: 24px;
  max-width: 24px;

  border-radius: 2px;
  margin-right: 4px;
}

.card-locales {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
}

.card-locales img {
  width: 16px;
  height: 16px;
  max-width: 16px;
  max-height: 16px;
  display: block;
}

.mode-badge.inside {
  background: var(--green-6-color);
}
.mode-badge.preorder {
  background: var(--yellow-4-color);
}
.mode-badge.delivery {
  background: var(--blue-4-color);
}
.mode-badge.hotels {
  background: var(--v1-grey-10-color);
}
.mode-badge.preview {
  background: var(--v1-grey-10-color);
}

.menu-card-selected .mode-badge.preview,
.menu-card-selected .mode-badge.hotels {
  background: var(--white-color);
}

.edit-icon {
  cursor: pointer;
}

.edit-block {
  display: flex;
}
</style>
